/**
 * Safely parse stringified object (skips boolean, number etc)
 * @param str JSON string containing stringified object
 */
export const safeJsonParser = <T = any>(str: string): T => {
  if (typeof str !== 'string') return null
  try {
    const result = JSON.parse(str)
    const type = Object.prototype.toString.call(result)
    if (type === '[object Object]' || type === '[object Array]') {
      return result
    }
    return null
  } catch (err) {
    return null
  }
}
